import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  PROJE_DASHBOARD_GENEL_STAT: any[];
  PROJE_DASHBOARD_GENEL_STAT_dummy: any[];
  GET_SON_10_PROJE: any[];
  GET_SON_10_PROJE_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp348551Visible: "visible" | "hidden";
  isComp323506Visible: "visible" | "hidden";
  isComp244740Visible: "visible" | "hidden";
}

export class HomePage_ScreenBase extends React.PureComponent<
  IHomePage_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;
  homepage_755300_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "50d048d7-a061-473c-b8dd-d0651a9f41f0",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 325247, PropertyName: "value", Value: "Toplam Proje" },
        { Id: 566275, PropertyName: "value", Value: "Devam Eden" },
        { Id: 602766, PropertyName: "value", Value: "Beklemede" },
        { Id: 778590, PropertyName: "value", Value: "Arıza Kaydı" },
        { Id: 978767, PropertyName: "value", Value: "Son Projeler" },
        { Id: 766808, PropertyName: "label", Value: "Yeni Proje" },
        { Id: 416887, PropertyName: "title", Value: "  Proje Adı" },
        { Id: 896688, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 104077, PropertyName: "title", Value: "Kategori" },
        { Id: 312669, PropertyName: "value", Value: "[datafield:kategori]" },
        { Id: 92867, PropertyName: "title", Value: "Müşteri" },
        { Id: 288886, PropertyName: "value", Value: "[datafield:musteriadi]" },
        { Id: 98932, PropertyName: "title", Value: "Durum" },
        { Id: 348551, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 323506, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 244740, PropertyName: "value", Value: "Beklemede" },
        { Id: 829389, PropertyName: "title", Value: "İlerleme" },
        { Id: 617147, PropertyName: "title", Value: "Başlangıç" },
        {
          Id: 782166,
          PropertyName: "value",
          Value: "[datafield:baslangictarihi]",
        },
        { Id: 911114, PropertyName: "title", Value: "Bitiş" },
        {
          Id: 785604,
          PropertyName: "value",
          Value: "[datafield:tahminibitis]",
        },
        { Id: 292926, PropertyName: "title", Value: "İşlemler" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.homepage_755300_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      PROJE_DASHBOARD_GENEL_STAT: [],
      GET_SON_10_PROJE: [],
      NAVIGATE: "",
      isComp348551Visible: "hidden",
      isComp323506Visible: "hidden",
      isComp244740Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "homepage",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "homepage",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "homepage",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROJE_DASHBOARD_GENEL_STAT =
      result?.data.projE_DASHBOARD_GENEL_STAT;
    formVars.homepage_536966_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
        : null
    );
    formVars.homepage_807027_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
        : null
    );
    formVars.homepage_32735_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
        : null
    );
    formVars.homepage_906638_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
        : null
    );
    stateVars.GET_SON_10_PROJE = result?.data.geT_SON_10_PROJE;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_536966_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].toplamProje
        : null
    );

    formVars.homepage_807027_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].devamEden
        : null
    );

    formVars.homepage_32735_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].beklemede
        : null
    );

    formVars.homepage_906638_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROJE_DASHBOARD_GENEL_STAT !== undefined
        ? stateVars.PROJE_DASHBOARD_GENEL_STAT?.length > 0
          ? stateVars.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
          : null
        : this.state.PROJE_DASHBOARD_GENEL_STAT?.length > 0
        ? this.state.PROJE_DASHBOARD_GENEL_STAT[0].arizaKaydi
        : null
    );

    stateVars.dataSource_755300 =
      stateVars.GET_SON_10_PROJE ?? this.state.GET_SON_10_PROJE;
    stateVars.isComp348551Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "homepage_755300_value", "durum"),
        "Tamamlandi"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp323506Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "homepage_755300_value", "durum"),
        "Devam Ediyor"
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(this, "homepage_755300_value", "durum"),
          "Taslak"
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp244740Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "homepage_755300_value", "durum"),
        "Beklemede"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_766808_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YeniProjeGenel",
      "ProjeCategory",
      ReactSystemFunctions.convertToTypeByName(null, "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "YeniProjeGenel",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "127650",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [127650] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
  }
}
